import styled from 'styled-components';

import { fromLarge, toMedium } from 'styleUtils/mediaQueries';

const avatarSmallSize = '70px';
export const Section = styled.section`
    display: flex;
    padding-top: 1.5rem;
    justify-content: center;

    ${fromLarge`
    padding: 50px 0 0;
  `}
    ${toMedium`
    .picture img {
      width: ${avatarSmallSize};
      max-width: ${avatarSmallSize};
      min-width: ${avatarSmallSize};
      height: ${avatarSmallSize};
      max-height: ${avatarSmallSize};
      min-height: ${avatarSmallSize};
    }
  `}
`;
